import { Database } from './types/supabase';

export interface ProductImage {
  id: string;
  url: string;
  order: number;
}

export const PRODUCT_TYPES = [
  'Used Gas Dryer',
  'New Gas Dryer',
  'Used Electric Dryer',
  'New Electric Dryer',
  'New Washer and Gas Dryer',
  'Used Washer and Gas Dryer',
  'New Washer and Electric Dryer',
  'Used Washer and Electric Dryer',
  'Used Stackable Washer and Gas Dryer',
  'New Stackable Washer and Electric Dryer',
  'Used Washer',
  'New Washer',
  'Used Stackable Washer and Electric Dryer'
] as const;

export type ProductType = typeof PRODUCT_TYPES[number];

export interface Product {
  id: string;
  name: string;
  brand: string;
  type: ProductType;
  collectionType: CollectionType;
  category: ProductCategory;
  price: number;
  images: ProductImage[];
  description: string;
  stockLevel: number;
  features: string[];
  dateAdded: string;
  popularity: number;
  isPublished: boolean;
  is_published: boolean;
  is_draft: boolean;
  is_deleted: boolean;
  barcode?: string;
}

export type CollectionType = 'Feature Item' | 'On Sale';

export type ProductCategory = 'New' | 'Used' | 'Like New';

export interface FilterState {
  brands: string[];
  types: string[];
  categories: string[];
  priceRange: [number, number];
  inStock: boolean;
}

export type SortOption = 'price-asc' | 'price-desc' | 'popularity' | 'newest' | 'brand';

export type BookingStatus = 'Pending' | 'Confirmed Install Date' | 'Done' | 'Return/Refund' | 'Voided';

export type RefundReason = 'Defective Product' | 'Installation Issues' | 'Customer Dissatisfaction' | 'Wrong Product' | 'Changed Mind' | 'Other';

export interface BookingFormValues {
  fullName: string;
  email?: string;
  phone: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  installationLocation: string;
  hasTrade: boolean;
  requiresHaulAway: boolean;
  notes?: string;
}

export interface Booking {
  id: string;
  order_number: string;
  customer_name: string;
  customer_email?: string;
  customer_phone: string;
  product: {
    id: string;
    name: string;
    price: number;
    brand: string;
    type: string;
    image?: string;
  };
  delivery_address: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
  };
  installation_location: string;
  has_trade: boolean;
  requires_haul_away?: boolean;
  notes?: string;
  status: BookingStatus;
  payment_method: string;
  delivery_schedule?: {
    date: string;
    time: string;
  };
  status_history: Array<{
    status: string;
    timestamp: string;
    note?: string;
  }>;
  refund?: {
    reason: RefundReason;
    details: string;
    date: string;
    amount: number;
  };
  created_at: string;
  updated_at: string;
}
